import React from "react";

const useOtherAssetsLocalSyncOnUnmount = (otherAssetsData, data, updateSharedData) => {

  // need to store latest states as ref to use in unmount
  const statesRef = React.useRef({otherAssetsData, data});
  React.useEffect(() => {
    statesRef.current = {otherAssetsData, data};
  }, [otherAssetsData, data]);

  React.useEffect(() => {
    return () => {
      if(!statesRef.current.data.loading && statesRef.current.data.updatedAt > statesRef.current.otherAssetsData.updatedAt){
        // update "cache" on unmount if changed
        updateSharedData(statesRef.current.data);
      }
    }
  }, []);
}

export default useOtherAssetsLocalSyncOnUnmount;